import React, {useEffect, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {Layout, Menu} from "antd";
import {
  AccountBookOutlined,
  AuditOutlined,
  BarsOutlined,
  PayCircleOutlined,
  SolutionOutlined,
  TeamOutlined,
  UserOutlined,
  BarChartOutlined
} from "@ant-design/icons";

const {Sider} = Layout;

export const SideMenu = () => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // path change
  }, [location.pathname]);

  return (
    <Sider
      theme="light"
      collapsible
      collapsed={collapsed}
      style={{zIndex: 999}}
      onCollapse={(collapseState) => setCollapsed(collapseState)}
    >
      <div className="logo"/>
      <Menu theme="light" defaultSelectedKeys={["analysis"]} mode="inline">
        <Menu.Item key="analysis" icon={<BarChartOutlined />}>
          <Link to="analysis">report</Link>
        </Menu.Item>
        <Menu.SubMenu key="jobs" icon={<SolutionOutlined/>} title="job list">
          <Menu.Item key="all_jobs">
            <Link to="all_jobs">all jobs</Link>
          </Menu.Item>
          <Menu.Item key="new_jobs">
            <Link to="all_jobs?status=0">new job</Link>
          </Menu.Item>
          <Menu.Item key="waiting_jobs">
            <Link to="all_jobs?status=1">Helper to be confirmed</Link>
          </Menu.Item>
          {/*<Menu.Item key="starting_jobs">*/}
          {/*  <Link to="starting_jobs">待開始</Link>*/}
          {/*</Menu.Item>*/}
          <Menu.Item key="in_progress_jobs">
            <Link to="all_jobs?status=2">in progress</Link>
          </Menu.Item>
          <Menu.Item key="completed_jobs">
            <Link to="all_jobs?status=3">completed</Link>
          </Menu.Item>
          <Menu.Item key="cancelled_jobs">
            <Link to="all_jobs?status=4">cancelled</Link>
          </Menu.Item>
          <Menu.Item key="late_checkout_jobs">
            <Link to="late_checkout_jobs">check in late</Link>
          </Menu.Item>
        </Menu.SubMenu>
        <Menu.Item key="helpers" icon={<TeamOutlined/>}>
          <Link to="helpers">helper list</Link>
        </Menu.Item>
        <Menu.Item key="employers" icon={<UserOutlined/>}>
          <Link to="employers">employer list</Link>
        </Menu.Item>
        <Menu.Item key="employer_invoices" icon={<AuditOutlined/>}>
          <Link to="employer_invoices">employer invoice</Link>
        </Menu.Item>
        <Menu.Item key="helper_payments" icon={<AccountBookOutlined/>}>
          <Link to="helper_payments">helper billing</Link>
        </Menu.Item>
        {/* <Menu.Item key="credit_debit_notes" icon={<FormOutlined />}>
          <Link to="credit_debit_notes">Credit Debit Notes</Link>
        </Menu.Item> */}
        <Menu.Item key="hepler_prices" icon={<BarsOutlined/>}>
          <Link to="hepler_prices">helper level price list</Link>
        </Menu.Item>
        <Menu.SubMenu
          key="accounting"
          icon={<PayCircleOutlined/>}
          title="accounting"
        >
          <Menu.Item key="accounting_report">
            <Link to="accounting_report">report</Link>
          </Menu.Item>
          <Menu.Item key="accounting_category">
            <Link to="accounting_category">project options</Link>
          </Menu.Item>
        </Menu.SubMenu>
      </Menu>
    </Sider>
  );
};
